import { Button, InputLabel, ListItem, Stack, Typography } from '@mui/material';
import { tab } from '@testing-library/user-event/dist/tab';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { useContext } from 'react';

interface ITagInputs {
  filterTags: { label: string; value: number }[];
  isActive: (tag: { label: string; value: number }) => boolean;
  toggleFilter: (tag: { label: string; value: number }) => void;
  resetTags: () => void;
}

export const TagsInput = ({
  filterTags,
  isActive,
  toggleFilter,
  resetTags,
}: ITagInputs) => {
  const { filters, setFilters, userLocation } = useContext(SuppliersContext);

  const isDesktop = useIsDesktop();

  return (
    <Stack gap={'24px'}>
      <Stack
        direction={'row'}
        gap={'16px 6px'}
        flexWrap={'wrap'}
        component={'ul'}
        padding={0}
        margin={0}
      >
        {filterTags.map((tag, index) => (
          <ListItem sx={{ padding: 0, width: 'fit-content' }} key={index}>
            <Button
              variant='primary2'
              onClick={() => toggleFilter(tag)}
              role={'toggle'}
              aria-pressed={isActive(tag)}
              aria-labelledby={tag.label}
              sx={{
                padding: '0px 15px',
                height: isDesktop ? '38px' : '32px',
                outline: (theme) =>
                  isActive(tag)
                    ? 'none'
                    : `1px solid ${theme.palette.primary.shade_100}`,
                background: (theme) =>
                  isActive(tag) ? theme.palette.primary.main : '#fff',
                color: (theme) =>
                  isActive(tag) ? '#fff' : theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: (theme) =>
                    isActive(tag) ? theme.palette.primary.main : '#fff',
                },
              }}
            >
              <InputLabel id={`label-chip-${tag.label}`}>
                <Typography
                  variant='body6'
                  color={isActive(tag) ? '#fff' : 'primary.main'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  {tag.label}
                </Typography>
              </InputLabel>
            </Button>
          </ListItem>
        ))}
        <Button
          variant='primary2'
          role={'toggle'}
          aria-pressed={userLocation ? true : false}
          aria-labelledby={
            Dictionary[DICTIONARY.Suppliers].resultPage.closestLocation
          }
          sx={{
            width: 'fit-content',
            padding: '0px 15px',
            height: isDesktop ? '38px' : '32px',
            outline: `1px solid #E7EDFF`,
            color: filters.location ? '#fff' : 'primary.main',
            bgcolor: filters.location ? 'primary.main' : '#fff',
            ':hover': {
              bgcolor: filters.location ? 'primary.main' : '#fff',
            },
          }}
          onClick={() => {
            const updatedFilters = {
              ...filters,
              location: filters.location ? null : userLocation,
            };
            setFilters(updatedFilters);
          }}
        >
          <Typography variant='body6'>
            {Dictionary[DICTIONARY.Suppliers].resultPage.closestLocation}
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
